import riderLocation from "@/components/modal/riderLocation/layout";
import openCompletedImage from "@/components/modal/openCompletedImage/layout";
import channelTalk from "@/helpers/channelTalk";
import mixinFilter from "@/mixins/mixinFilter";
import orderTag from "@/components/common/orderTag.vue";
import mixinVehicle from "@/mixins/mixinVehicle";
import toast from "./toast.vue";
import dayjs from "dayjs";

export default {
  mixins: [mixinFilter, mixinVehicle],
  metaInfo: {
    title: "주문 상세 정보"
  },
  components: {
    riderLocation,
    openCompletedImage,
    orderTag,
    toast
  },
  data() {
    return {
      loadingRiders: true,
      loadingOrders: true,
      riderLocationModalStatus: false,
      completedImageModalStatus: false,
      order: null,
      rider: null,
      imageUrl: "",
      imageModalData: {
        completedImageModalStatus: false,
        imageUrl: "",
        completedAt: "",
        status: ""
      },
      openToggle: true,
      toastList: []
    };
  },
  methods: {
    mergeItem(item) {
      const result = [];
      for (const key in item) {
        if (key !== "weight" && key !== "fragile") {
          if (key === "etc") {
            if (item[key] !== null) {
              result.push(`${item[key]}`);
            }
          } else if (item[key] > 0) {
            result.push(`${this.mixinsItemTitle(key)} ${item[key]}개`);
          }
        }
      }
      return result.join(" | ").replace(/\s*\|\s*$/, "");
    },
    backAction() {
      this.$router.go(-1);
    },
    sumAdditionalPrice(additionalPrice) {
      let amount = 0;
      for (let i = 0; i < additionalPrice.length; i++) {
        amount = amount + additionalPrice[i].amount;
      }
      return amount;
    },
    openRiderMap() {
      this.riderLocationModalStatus = true;
    },
    openImage(url, completedAt, status) {
      this.imageModalData.imageUrl = url;
      this.imageModalData.completedAt = completedAt;
      this.imageModalData.status = status;
      this.imageModalData.completedImageModalStatus = true;
    },
    showReceipt(urls) {
      if (urls.length > 0) {
        for (let url of urls) {
          window.open(url);
        }
      } else {
        alert("영수증이 존재하지않습니다.");
      }
    },
    async updateClientMemo() {
      const result = await this.$store.dispatch("orders/updateClientMemo", {
        orderId: this.order._id,
        payload: {
          clientMemo: this.order.clientMemo
        }
      });

      if (result.success) {
        this.toast("저장되었습니다.");
      } else {
        alert("저장에 실패했습니다.");
      }
      this.getOrderDetail();
    },

    toast(string) {
      this.toastList.push({
        msg: string,
        date: dayjs().valueOf()
      });

      setTimeout(() => {
        this.toastList.shift();
      }, 3000);
    },

    async getOrderDetail() {
      const vm = this;
      try {
        this.order = await this.$store.dispatch(
          "orders/orderDetail",
          this.$route.params.orderId
        );
        this.loadingOrders = false;
        vm.order = vm.order.order;

        if (this.order.riderId) {
          vm.$store
            .dispatch("users/getRiderInfo", vm.order._id)
            .then((result) => {
              this.rider = result.rider;
            })
            .catch((e) => {
              console.error(e);
              return alert("파트너 정보조회 중 에러가 발생하였습니다");
            })
            .finally(() => {
              this.loadingRiders = false;
            });
        } else {
          this.loadingRiders = false;
        }
      } catch (error) {
        console.error(error);
        alert("서버에러가 발생하였습니다");
        this.loadingOrders = false;
      }
    }
  },
  computed: {
    locationAvailable: {
      get() {
        const available = ["waiting", "ongoing"];
        if (available.indexOf(this.order.status) !== -1) {
          return true;
        }
        return false;
      }
    }
  },
  async created() {
    await this.getOrderDetail();
  }, // end of created
  async mounted() {
    channelTalk.updateOrderId(this.$route.params.orderId);
  },
  async destroyed() {
    channelTalk.updateOrderId(null);
  }
};
